import GoInfo from '@meronex/icons/go/GoInfo';
import icon from './StyledIcon';
export default icon(GoInfo);
